import React, { useContext, useEffect, useState } from 'react'
import { COSMOS_API, POST_ENDPOINT } from '../api/API'
import { AdminContext } from '../contexts/AdminContext';
import Button from '@mui/material/Button';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import ErrorIcon from '@mui/icons-material/Error';
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import { Alert, Typography } from '@mui/material';

interface ContactUsProps {
    actionPopup: boolean,
    setActionPopup: React.Dispatch<React.SetStateAction<boolean>>,
}

interface ContactUsRequest {
    requesterId: string,
    name: string;
    email: string;
    applicationId: string;
    message: string;
    title: string;
}

const initRequest: ContactUsRequest = {
    title: "other",
    name: "",
    requesterId: "",
    email: "",
    applicationId: "",
    message: ""
}

export const ContactUs = (props: ContactUsProps) => {
    const [submitInProgress, setSubmitInProgress] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>("Something went wrong. Your ticket was not submitted");
    const [errorblock, setErrorblock] = useState<"invalid" | "success" | "failure" | "">("");
    const [initialRequest, setInitialRequest] = useState<ContactUsRequest>(initRequest);
    const { adminCredentials, getToken, getTokenClaims } = useContext(AdminContext);
    const [searchableApplications, setSearchableApplications] = useState<Array<{ id: string, label: string }>>([]);
    const [request, setRequest] = useState<ContactUsRequest>(initialRequest);

    const closePopup = () => {
        props.setActionPopup(false);
    }

    useEffect(() => {
        const allApps = Object.keys(adminCredentials.allApplications)
            .filter((appKey) => adminCredentials.allApplications[appKey].isGlobal)
            .map(appKey => { return { id: appKey, label: adminCredentials.allApplications[appKey]?.name } })
            .sort((a, b) => a.label <= b.label ? -1 : 1);

        let _initialReq = { ...initRequest };
        getTokenClaims().then((response) => {
            _initialReq = {
                // @ts-ignore
                ..._initialReq, ["name"]: (response['family_name'] || "") + ", " + (response['given_name'] || ""),
                ["requesterId"]: adminCredentials.id,
                ["email"]: adminCredentials.id,
                ["applicationId"]: allApps.length > 0 ? allApps[0].id : ""
            };
            setInitialRequest(_initialReq);
        });
        setSearchableApplications(allApps);

    }, [adminCredentials]);

    useEffect(() => {
        setRequest(initialRequest);
    }, [initialRequest]);

    const handleReqChange = (param: "applicationId" | "message", value: string) => {
        setRequest({ ...request, [param]: value });
    }

    const sendRequest = async () => {
        if (request.applicationId == "") {
            setErrorblock("invalid");
            return;
        } else {
            setErrorblock("");
            if (!submitInProgress) {
                setSubmitInProgress(true);
                const requestToPost = {...request, message: "Support request from DUA Portal: " + (request.message ?? "")};

                const results = await COSMOS_API.POST(requestToPost, POST_ENDPOINT.WriteSupportRequest, getToken());

                if (results.ok && results.respBody !== undefined && results.respBody !== null) {
                    setSubmitInProgress(false);
                    setRequest(initialRequest);
                    setErrorblock("success");
                    setTimeout(() => {
                        setErrorblock("");
                    }, 5000);
                } else {
                    setSubmitInProgress(false);
                    setErrorblock("failure");
                    setErrorMsg(results && results.respBody && results.respBody.userMessage);
                }
            }
        }
    }


    return (
        <Dialog open={props.actionPopup} onClose={closePopup} fullWidth maxWidth={'md'}>
            <DialogTitle>Contact Us</DialogTitle>
            <CloseIcon className='close-btn white' onClick={closePopup} />
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column' }} >
                    <Alert severity="error" sx={{ display: errorblock == "invalid" ? "inherit" : "none" }} >Please select an application.</Alert>
                    <Alert sx={{ color: '#fff', backgroundColor: 'green', display: errorblock == "success" ? "inherit" : "none" }} variant="filled" >Thank you, your ticket has been submitted.</Alert>
                    <Alert icon={<ErrorIcon fontSize="inherit" />} sx={{ color: '#fff', backgroundColor: '#d32f2f', display: errorblock == "failure" ? "inherit" : "none" }} variant="standard" id="error-msg">{errorMsg}</Alert>

                    <Autocomplete
                        id="applicationId"
                        disableClearable
                        className='mt1'
                        fullWidth
                        value={searchableApplications.find(app => app.id === request.applicationId) ?? searchableApplications[0]}
                        options={searchableApplications}
                        renderInput={(params) =>
                            <TextField {...params} label={`Which application is your question about?`} />
                        }
                        onChange={(_: any, value) => handleReqChange('applicationId', value.id)}
                    />

                    <Box sx={{ display: 'flex', flexDirection: 'row' }} className="mt1" >

                        <TextField
                            sx={{ marginRight: '20px', flex: 1 }}
                            label="Name"
                            disabled
                            value={request.name}
                        />

                        <TextField
                            sx={{ flex: 1 }}
                            label="Email"
                            disabled
                            value={request.email}
                        />
                    </Box>
                    <Typography sx={{ marginTop: '20px' }} variant='h6'>Message</Typography>
                    {/* <textarea name="contactComments" value={request.message} id="contact-comments" onChange={(e: any) => handleReqChange('message', e.target.value)} rows={10} placeholder="Enter your message here" /> */}
                </Box>

            </DialogContent>
            <DialogActions>
                <Button
                    className="danger"
                    onClick={() => props.setActionPopup(false)}
                >
                    Cancel
                </Button>
                <Button onClick={sendRequest} >
                    Send
                </Button>
            </DialogActions>

        </Dialog>
    )
}

